(function($) {

	'use strict';

	var init = function() {
        tooltipHandler();
    };
    
    var tooltipHandler = function(){
        $('.btn').click(function() {
            $(this).toggleClass('hover');
            //$(this).next().addClass('active');
            $(this).next().toggleClass('hover');
        });

        $('body').on('click',function(event){
            if(!$(event.target).is('.btn')){
              $(".btn").removeClass("hover");
              $(".tooltip").removeClass("hover");
            }
        });
    }

    

	$(document).ready(function() {
		init();
	});

})(jQuery);
